import { Button } from 'components';
import { useEffect, useRef, useState } from 'react';

import { Icon } from 'components';
import './Message.scss';

const MessageConversation = ({ data, onBack }) => {
  const { username, avatar, isLive = true } = data;
  const myAvatar = 'https://api.dicebear.com/9.x/avataaars/svg?seed=Me';
  const messagesEndRef = useRef(null);

  // Dummy conversation history based on the selected user
  const INITIAL_HISTORY = [
    {
      id: 1,
      sender: 'me',
      text: 'Hi, how are you?',
      time: '10:00 AM',
    },
    {
      id: 2,
      sender: 'them',
      text: 'I am good, thanks for asking! How about you?',
      time: '10:05 AM',
    },
    {
      id: 3,
      sender: 'me',
      text: 'Doing great. Just wanted to check on the progress.',
      time: '10:10 AM',
    },
    {
      id: 4,
      sender: 'them',
      text: 'We are making good progress. Will share an update soon.',
      time: '10:15 AM',
    },
    {
      id: 5,
      sender: 'them',
      text: 'Is there anything specific you need?',
      time: '10:16 AM',
    },
    {
      id: 6,
      sender: 'me',
      text: 'Could you update the color scheme on the dashboard? The blue seems a bit too dark on the mobile view.',
      time: '10:20 AM',
    },
    {
      id: 7,
      sender: 'them',
      text: 'Sure thing. I will check the contrast ratios and adjust it accordingly. Should I aim for the primary brand blue?',
      time: '10:22 AM',
    },
    {
      id: 8,
      sender: 'me',
      text: 'Yes, that would be perfect. Also, verify the font sizes on the settings page.',
      time: '10:25 AM',
    },
    {
      id: 9,
      sender: 'them',
      text: 'Noted. I am working on the responsive layout right now, so I will include those fixes in the next commit.',
      time: '10:30 AM',
    },
    {
      id: 10,
      sender: 'me',
      text: 'Great. Let me know when it is deployed to staging.',
      time: '10:35 AM',
    },
    {
      id: 11,
      sender: 'them',
      text: 'Will do! Should be ready by EOD.',
      time: '10:40 AM',
    },
    {
      id: 12,
      sender: 'me',
      text: 'Thanks! Appreciate the quick turnaround.',
      time: '10:42 AM',
    },
  ];

  const [history, setHistory] = useState(INITIAL_HISTORY);
  const [messageText, setMessageText] = useState('');

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Reset history when switching users (dummy implementation)
  useEffect(() => {
    setHistory(INITIAL_HISTORY);
    setMessageText('');
  }, [data.id]);

  // Auto-scroll when history changes
  useEffect(() => {
    scrollToBottom();
  }, [history]);

  const handleSendMessage = () => {
    if (!messageText.trim()) return;

    const newMessage = {
      id: Date.now(),
      sender: 'me',
      text: messageText,
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      }),
    };

    setHistory((prev) => [...prev, newMessage]);
    setMessageText('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div className='message-conversation'>
      <div className='message-conversation__header'>
        <button className='back-button' onClick={onBack}>
          &larr;
        </button>
      </div>

      <div className='message-conversation__body'>
        {history.map((msg) => (
          <div
            key={msg.id}
            className={`chat-bubble chat-bubble--${msg.sender}`}
          >
            <div className='chat-bubble__avatar'>
              <img src={msg.sender === 'me' ? myAvatar : avatar} alt='avatar' />
            </div>
            <div className='chat-bubble__content'>
              <div className='chat-bubble__text'>{msg.text}</div>
              <div className='chat-bubble__time'>{msg.time}</div>
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className='message-conversation__footer'>
        <input
          type='text'
          placeholder='Type a message...'
          className='message-input'
          value={messageText}
          onChange={(e) => setMessageText(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button
          onClick={handleSendMessage}
          disabled={!messageText.trim()}
          className={!messageText.trim() ? 'disabled' : ''}
        >
          <Icon name='Paper_Plane' />
        </Button>
      </div>
    </div>
  );
};

export default MessageConversation;
